import CompsManager from '@/manager/2.6/CompsManager';
import ICompAddress from '@/models/CompAddress';

export default {
    /**
     * Set the active comp from the given index. Subject is 0.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param index
     */
    setActiveComp(index: number) {
        CompsManager.setActiveComp(index);
    },

    /**
     * Back fill any missing fields for a comp in the store based on the given comp address and the
     * current form code. Affects the comp's source data (aka transfer data).
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param comp
     */
    async backFillMissingFields(compAddress: ICompAddress): Promise<void> {
        await CompsManager.backFillMissingFields(compAddress);
    },
};
